// extracted by mini-css-extract-plugin
export default {"monsterCell":"MonsterCell_monsterCell__Swqo9","monsterImage":"MonsterCell_monsterImage__oe+th"};